import React from 'react';

import { Badge, Text } from '@change/ds-core-ui';
import { DecisionMakerIcon } from '@change/ds-icons/DecisionMakerIcon';

import { TranslatePlural, useI18n } from '@change-corgi/core-react/i18n';

import { Location } from '../../../shared/components/Location';
import type { LegislativeBody } from '../../../shared/types';
import { MemberList } from '../MemberList';

type BodyContentProps = {
	legislativeBody: LegislativeBody;
	viewMoreTrigger?: React.ReactNode;
};

export const BodyContent: React.FC<BodyContentProps> = ({ legislativeBody, viewMoreTrigger }) => {
	const { title, location, responseCount, allDMs } = legislativeBody;
	const { translatePlural } = useI18n();

	return (
		<>
			<div className="flex">
				<div>
					<div className="bg-fill-information-weaker mr-4 flex size-16 items-center justify-center rounded-full lg:size-20">
						<DecisionMakerIcon size="large" className="text-icon-information" />
					</div>
				</div>
				<div className="w-full">
					<div className="flex flex-col gap-2 lg:flex-row lg:items-start">
						<div className="w-fit flex-wrap lg:flex">
							<div>
								<Text variant="heading" size="x-small">
									{title}
								</Text>
								<Text variant="heading" size="x-small" className="mr-1.5 hidden lg:inline">
									,
								</Text>
							</div>

							<Text variant="body" size="large" fontWeight="light">
								<TranslatePlural
									value="corgi.petition_gamma.decision_makers_v2.legislative_body.members_count"
									replacements={{ membersCount: allDMs.length }}
									count={allDMs.length}
								/>
							</Text>
						</div>

						<div className="min-w-32 lg:ml-auto">
							{responseCount > 0 && (
								<Badge
									label={translatePlural(
										'corgi.petition_gamma.decision_makers_v2.legislative_body.responded_count',
										responseCount,
										{ responseCount },
									)}
									variant="success"
									emphasis="weaker"
									className="w-fit lg:ml-auto"
								/>
							)}
						</div>
					</div>

					<div className="hidden lg:block">
						{location && (
							<div className="mt-1">
								<Location location={location} />
							</div>
						)}

						<MemberList legislativeBody={legislativeBody} testId="members-desktop" viewMoreTrigger={viewMoreTrigger} />
					</div>
				</div>
			</div>
			<div className="mx-8 lg:hidden">
				<MemberList legislativeBody={legislativeBody} testId="members-mobile" viewMoreTrigger={viewMoreTrigger} />
			</div>
		</>
	);
};
